export const LOCATION_ACTION_TYPES = {
  LOCATION_SET_DATA_BY_KEY: 'LOCATION_SET_DATA_BY_KEY',
  LOCATION_SET_LINK_BY_KEY: 'LOCATION_SET_LINK_BY_KEY',
  LOCATION_CHANGE_PROCESSING: 'LOCATION_CHANGE_PROCESSING',
};

export function setLocationDataByKey(data, stateKeyForDataSaving) {
  return {
    type: LOCATION_ACTION_TYPES.LOCATION_SET_DATA_BY_KEY,
    payload: {
      data,
      stateKeyForDataSaving,
    },
  };
}

export function changeLocationProcessingState(newState) {
  return {
    type: LOCATION_ACTION_TYPES.LOCATION_CHANGE_PROCESSING,
    payload: newState,
  };
}

export function getLocationsData(pageObject, stateKeyForDataSaving, methodUrl) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeLocationProcessingState(true));

    const response = await axios.get(methodUrl);

    dispatch(changeLocationProcessingState(false));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    const { data = {}, accessRequest, hasAccess } = response;
    data.hasAccess = hasAccess;

    dispatch(setLocationDataByKey(data, stateKeyForDataSaving));

    if (accessRequest !== undefined) {
      dispatch(setLocationDataByKey(accessRequest, 'accessRequest'));
    }

    return response;
  };
}

export function getIndependentIrbTemplateData(pageObject, methodUrl) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeLocationProcessingState(true));

    const response = await axios.get(methodUrl);

    dispatch(changeLocationProcessingState(false));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    return response;
  };
}
